// client/src/components/Admin/TentativeTable.js
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

// Material UI Components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import ReactTable from "components/ReactTable/ReactTable.js";

// Icons
import Assignment from "@material-ui/icons/Assignment";

// Styles
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

const stylesCard = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    textAlign: "left",
  },
};

const useStylesCard = makeStyles(stylesCard);

const TentativeTable = ({ tentatives, tentativeData }) => {
  const classes = useStylesCard();

  // Only render if there are tentatives
  if (!tentatives || tentatives.length === 0) {
    return null;
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="info" icon>
            <CardIcon color="info">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Tentative Members Table</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              columns={[
                {
                  Header: "Name",
                  accessor: "name",
                },
                {
                  Header: "Institution",
                  accessor: "institution",
                },
                {
                  Header: "Email",
                  accessor: "email",
                },
                {
                  Header: "Message",
                  accessor: "message",
                },
                {
                  Header: "Actions",
                  accessor: "actions",
                },
              ]}
              data={tentativeData}
              defaultPageSize={20}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

TentativeTable.propTypes = {
  tentatives: PropTypes.array.isRequired,
  tentativeData: PropTypes.array.isRequired,
};

export default TentativeTable;
